import React from "react";
import { useSelector } from "react-redux";
import { Controller } from "react-hook-form";
import Dropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import ToggleableButton from "../../../../components/toggleableButton/toggleableButton";
import { Input } from "../../../../components/form/Input/Input";

export const Retention = ({ control, register, showFutureAppointments }) => {
  const { defaultConversionRevenueTypes } = useSelector(
    (state) => state.organizations.commonSettings
  );

  return (
    <>
      <div className="admin-organizations__section">
        <Input
          label="Exclude client prospect types (comma separated)"
          placeholder="ClassPass, 1st Visit, Single Class (comma separated)"
          htmlFor="exclude_client_prospect_types"
          customProps={register("exclude_client_prospect_types")}
        />
      </div>

      <div className="admin-organizations__section">
        <div className="switch">
          <p className="switch__title">Exclude zero amounts from retention calculation</p>
          <Controller
            control={control}
            name="zero_retention"
            render={({ field: { onChange, value } }) => {
              return (
                <div className={`switch__content ${value ? "switch__content--active" : ""}`}>
                  <ToggleableButton
                    isRadio
                    title="zeroRetention"
                    isActive={value}
                    onClick={(isActive) => onChange(isActive)}
                  />
                </div>
              );
            }}
          />
        </div>

        <div className="switch">
          <p className="switch__title">Same day conversion</p>
          <Controller
            control={control}
            name="count_same_day_conversion"
            render={({ field: { onChange, value } }) => {
              return (
                <div className={`switch__content ${value ? "switch__content--active" : ""}`}>
                  <ToggleableButton
                    isRadio
                    title="countSameDayConversion"
                    isActive={value}
                    onClick={(isActive) => onChange(isActive)}
                  />
                </div>
              );
            }}
          />
        </div>
      </div>

      <div className="admin-organizations__section">
        <div className="admin-organizations__dropdown">
          <p>Conversion/enrollment types</p>
          <Controller
            control={control}
            name="default_conversion_revenue_types"
            render={({ field: { onChange, value } }) => {
              return (
                <Dropdown
                  valueKey="name"
                  height={275}
                  haveOnSelectChange
                  enableOnly
                  options={defaultConversionRevenueTypes}
                  selectedFilters={value ?? []}
                  numberDisplayed={0}
                  onSelectChange={(data) => onChange(data)}
                />
              );
            }}
          />
        </div>

        <div className="admin-organizations__empty" />
      </div>

      <div className="admin-organizations__section">
        <div className="switch">
          <p className="switch__title">Show future bookings on funnel laser chart</p>
          <Controller
            control={control}
            name="show_future_appointments_on_funnel_laser"
            render={({ field: { onChange, value } }) => {
              return (
                <div className={`switch__content ${value ? "switch__content--active" : ""}`}>
                  <ToggleableButton
                    isRadio
                    title="show_future_appointments_on_funnel_laser"
                    isActive={value}
                    onClick={(isActive) => onChange(isActive)}
                  />
                </div>
              );
            }}
          />
        </div>
        {showFutureAppointments && (
          <div className="switch">
            <p className="switch__title">Show future bookings by default</p>
            <Controller
              control={control}
              name="show_future_appointments_by_default"
              render={({ field: { onChange, value } }) => {
                return (
                  <div className={`switch__content ${value ? "switch__content--active" : ""}`}>
                    <ToggleableButton
                      isRadio
                      title="show_future_appointments_by_default"
                      isActive={value}
                      onClick={(isActive) => onChange(isActive)}
                    />
                  </div>
                );
              }}
            />
          </div>
        )}
      </div>
    </>
  );
};
